
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAisLocatingdeviceActiveSelectedIec as ObiAisLocatingdeviceActiveSelectedIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ais-locatingdevice-active-selected-iec.js';
 
 
 

 
 export const ObiAisLocatingdeviceActiveSelectedIec = createComponent({
   react: React,
   tagName: 'obi-ais-locatingdevice-active-selected-iec',
   elementClass: ObiAisLocatingdeviceActiveSelectedIecElement,
   events: {
     
   }
  });
 
 